module.exports = __webpack_public_path__ + "static/assets/will-buck-profile.04c9258.png";